import DialogHeader from './DialogHeader';
import React from 'react';
import PropTypes from 'prop-types';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import { resolve } from '@cvent/nucleus-dynamic-css';

export default class ShareDialog extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    onClose: PropTypes.func,
    closeFallbackText: PropTypes.string,
    style: PropTypes.object,
    classes: PropTypes.object,
    children: PropTypes.node
  }
  render() {
    const {
      title,
      onClose,
      closeFallbackText,
      style,
      classes,
      children
    } = this.props;
    return (
      <div {...resolveTestId(this.props)}>
        { (title || onClose) &&
          <DialogHeader
            text={title}
            onClose={onClose}
            closeFallbackText={closeFallbackText}
            style={style}
            classes={classes}
          />
        }
        <div {...resolve(this.props, 'content')}>
          {children}
        </div>
      </div>
    );
  }
}
